import {mutationTypes} from '#/notes/store/authors/mutationTypes'

const mutations = {
  [mutationTypes.SET_AUTHORS] (state, authors) {
    state.authors = authors
  }
}

export default mutations
